import { trackInternalEvent } from '@rio/tracking'
import { useEffect } from 'react'
import ModalOverlay from 'builder/components/ModalOverlay'
import { Icon20 } from 'builder/components/Icon'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { useI18n } from 'builder/hooks/useI18n'
import CRITIQUE_IMG from './critique.png'

import {
  Close,
  Content,
  Info,
  Title,
  Subtitle,
  ItemsTitle,
  Items,
  Item,
  Check,
  ItemText,
  GetButton,
  ImagesContainer,
  ImagesTitle,
  CritiqueImg,
} from './styles'

interface Props {
  onClose?: () => void
  redirectUrl: string
  resumeIdToSendToCritique: number
}

const CritiqueFreeUserModal = ({ onClose, redirectUrl, resumeIdToSendToCritique }: Props) => {
  const { i18n } = useI18n()

  useEffect(() => {
    trackInternalEvent('see_resume_critique_promo_modal')
  }, [])

  return (
    <ModalOverlay overlayFadeDuration={350} contentSlideDuration={350}>
      <Content>
        <Close
          onClick={() => {
            onClose && onClose()
          }}
        >
          <Icon20.Close />
        </Close>
        <Info>
          <Title>{i18n.t('builder.critique_entry_points.critique_free_user_modal.title')}</Title>
          <Subtitle>
            {i18n.t('builder.critique_entry_points.critique_free_user_modal.subtitle')}
          </Subtitle>
          <ItemsTitle>
            {i18n.t('builder.critique_entry_points.critique_free_user_modal.items.title')}
          </ItemsTitle>
          <Items>
            <Item>
              <Check />
              <ItemText>
                {i18n.t('builder.critique_entry_points.critique_free_user_modal.items.one')}
              </ItemText>
            </Item>
            <Item>
              <Check />
              <ItemText>
                {i18n.t('builder.critique_entry_points.critique_free_user_modal.items.two')}
              </ItemText>
            </Item>
            <Item>
              <Check />
              <ItemText>
                {i18n.t('builder.critique_entry_points.critique_free_user_modal.items.three')}
              </ItemText>
            </Item>
            <Item>
              <Check />
              <ItemText>
                {i18n.t('builder.critique_entry_points.critique_free_user_modal.items.four')}
              </ItemText>
            </Item>
          </Items>
          <GetButton
            onClick={() => {
              sessionStorage.setItem('sendToCritique', String(resumeIdToSendToCritique))
              onClose && onClose()
              goToBillingPlanPage({
                onSuccessRedirect: redirectUrl,
              })
            }}
          >
            {i18n.t('builder.critique_entry_points.critique_free_user_modal.get')}
          </GetButton>
        </Info>
        <ImagesContainer>
          <ImagesTitle>
            {i18n.t('builder.critique_entry_points.critique_free_user_modal.images')}
          </ImagesTitle>
          <CritiqueImg src={CRITIQUE_IMG} />
        </ImagesContainer>
      </Content>
    </ModalOverlay>
  )
}
export default CritiqueFreeUserModal
